var _excluded = ["part", "prefix", "position", "owner", "enableDragMask", "enableInvalidTooltip", "dragMaskSelectType", "enableDragMaskReverseMode", "hideNextYear", "hidePrevYear", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { RangeState, useMonthView } from '../../../hooks/date';
import { classnames, format, flat, cutArray } from '@okee-uikit/react-utils';
import React, { Fragment, memo, useCallback, useMemo } from 'react';
import { useLocale, usePrefixCls } from '@okee-uikit/react-config';
import { useDateState } from '../hooks/useDateState';
import { ViewCol } from '../units/ViewCol';
import { ViewGrid } from '../units/ViewGrid';
import { ViewNav } from '../units/ViewNav';
import { ViewRow } from '../units/ViewRow';
import { ViewFrameSelect } from '../units/ViewFrameSelect';
import { useDateContentContext } from '../context/dateContent';
export function MonthViewItem(props) {
  var locale = useLocale('date');
  var item = props.item,
      enableDragMask = props.enableDragMask,
      prefix = props.prefix,
      onSelect = props.onSelect,
      onHover = props.onHover;
  var month = item.month,
      key = item.key,
      disabledState = item.disabledState;

  var _useDateContentContex = useDateContentContext(),
      monthRender = _useDateContentContex.monthRender;

  var disabled = disabledState !== RangeState.NONE;
  var isItemSelectable = enableDragMask && !disabled;
  var onClick = useCallback(function () {
    if (disabled) {
      return;
    }

    onSelect(item);
  }, [item, disabled, onSelect]);
  var onMouseEnter = useCallback(function () {
    if (disabled) {
      return;
    }

    onHover && onHover(item);
  }, [item, disabled, onHover]);
  var cls = classnames(usePrefixCls(prefix, {
    item: true,
    month: true
  }, true), useDateState(prefix, item));
  return React.createElement("div", {
    className: cls,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    "data-date-key": isItemSelectable ? key : undefined
  }, monthRender ? monthRender(item) : locale.monthList[month]);
}
export function MonthViewTitle(props) {
  var year = props.year,
      changeToYear = props.changeToYear,
      prefix = props.prefix;
  var locale = useLocale('date.year');
  var cls = usePrefixCls(prefix, {
    title: true,
    month: true
  }, true);
  var itemCls = usePrefixCls(prefix, {
    'title-item': true,
    month: true
  }, true);
  return React.createElement("div", {
    className: cls,
    onClick: changeToYear
  }, React.createElement("span", {
    className: itemCls
  }, " ", format(locale, {
    year: year
  })));
}
export var MonthView = memo(function (props) {
  var part = props.part,
      prefix = props.prefix,
      position = props.position,
      owner = props.owner,
      enableDragMask = props.enableDragMask,
      enableInvalidTooltip = props.enableInvalidTooltip,
      dragMaskSelectType = props.dragMaskSelectType,
      enableDragMaskReverseMode = props.enableDragMaskReverseMode,
      hideNextYear = props.hideNextYear,
      hidePrevYear = props.hidePrevYear,
      className = props.className,
      extra = _objectWithoutProperties(props, _excluded);

  var _useMonthView = useMonthView(part),
      year = _useMonthView.year,
      setCurrentMonth = _useMonthView.setCurrentMonth,
      setCurrentMonthVirtual = _useMonthView.setCurrentMonthVirtual,
      propMonthList = _useMonthView.monthList,
      prevYear = _useMonthView.prevYear,
      nextYear = _useMonthView.nextYear,
      changeToYear = _useMonthView.changeToYear;

  var _useDateContentContex2 = useDateContentContext(),
      monthDateFilter = _useDateContentContex2.monthDateFilter;

  var monthList = useMemo(function () {
    if (monthDateFilter) {
      var flatMonthList = flat(propMonthList);
      var filterList = monthDateFilter(flatMonthList);
      return cutArray(filterList, 3);
    } else return propMonthList;
  }, [propMonthList, monthDateFilter]);
  var cls = classnames(usePrefixCls(prefix, {
    view: true,
    month: true,
    owner: owner,
    position: position
  }, true), className);
  var content = React.createElement(Fragment, null, React.createElement(ViewNav, {
    isDoublePrevHidden: hidePrevYear,
    isDoubleNextHidden: hideNextYear,
    isNextHidden: true,
    isPrevHidden: true,
    doublePrev: prevYear,
    doubleNext: nextYear,
    type: "month",
    prefix: prefix
  }, React.createElement(MonthViewTitle, {
    prefix: prefix,
    year: year,
    changeToYear: changeToYear
  })), React.createElement(ViewGrid, {
    prefix: prefix,
    type: "month",
    position: position
  }, monthList.map(function (row) {
    return React.createElement(ViewRow, {
      prefix: prefix,
      key: row[0].key,
      type: "month",
      cols: row
    }, row.map(function (col) {
      return React.createElement(ViewCol, {
        enableInvalidTooltip: enableInvalidTooltip,
        prefix: prefix,
        type: "month",
        state: col,
        key: col.key
      }, React.createElement(MonthViewItem, {
        prefix: prefix,
        item: col,
        enableDragMask: enableDragMask,
        onSelect: setCurrentMonth,
        onHover: setCurrentMonthVirtual
      }));
    }));
  })));

  if (enableDragMask) {
    return React.createElement(ViewFrameSelect, _objectSpread(_objectSpread({}, extra), {}, {
      className: cls,
      part: part,
      prefix: prefix,
      dragMaskSelectType: dragMaskSelectType,
      enableDragMask: enableDragMask,
      enableDragMaskReverseMode: enableDragMaskReverseMode
    }), content);
  }

  return React.createElement("div", _objectSpread(_objectSpread({}, extra), {}, {
    className: cls
  }), content);
});